import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';

import { getDistributors } from 'actions/asyncActions';

@withAsyncActions({
    getDistributors,
}, { dispatchOnMount: true })
export default class ProjectDistributors extends Component {
    render() {
        const { data: { distributors = [] }, meta } = this.props.getDistributors;
        const { id, app } = this.props;

        const d = distributors.find((d) => d.id === id);

        if (!meta.success || !d) return null;

        return (
            <span key={app}>
                {d.name}
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/fields/project/ProjectDistributors.js